import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import Cookies from 'js-cookie'
import AuthPage from './pages/AuthPage.vue'
import ChangePasswordPage from './pages/ChangePassword.vue'
import ForgotPasswordPage from './pages/ForgotPassword.vue'
import GeneratePasswordPage from './pages/GeneratePassword.vue'
/**
 * Auto Approve Consent Grant Page
 * auto approve consent grant page
 * please if want to add new feature consent collector adjust in this page.
 * TODO:
 * - add prevention get details consent details if whitelisted services redirect to manual form consent grant page.
 */
import AutoApproveConsentGrantPage from './pages/DatagateConsent.vue'
/**
 * Manual Form Consent Grant Page
 * generic form consent grant page
 * please if want to add new feature consent collector adjust in this page.
 */
import FormConsentGrantPage from './pages/ConsentGrant.vue'
import ValidateMFAPage from './pages/ValidateMFA.vue'
import SetupMFAPage from './pages/SetupMFA.vue'

Vue.use(VueRouter)

function extractRedirectUrl(route: Route) {
	const url = route.query.redirect_url + route.hash
	let redirectUrl = url

	try {
		redirectUrl = decodeURIComponent(url)
		const parsed = new URL(redirectUrl)
		if (parsed.hostname !== window.location.hostname) {
			redirectUrl = ''
		} else {
			redirectUrl = parsed.href
		}
	} catch (e) {
		redirectUrl = ''
	}

	return redirectUrl
}

const routes: Array<RouteConfig> = [
	{
		path: '/login-page',
		name: 'signin',
		/* @ts-ignore */
		component: AuthPage,
		props: (route: Route) => ({
			redirectUrl: extractRedirectUrl(route),
			authType: 'signin'
		}),
		alias: '/',
	},
	{
		path: '/lupa-kata-sandi',
		name: 'forgot_password',
		component: ForgotPasswordPage,
	},
	{
		path: '/mfa',
		name: 'mfa',
		/* @ts-ignore */
		component: ValidateMFAPage,
	},
	{
		path: '/mfa-setup',
		name: 'mfa-setup',
		/* @ts-ignore */
		component: SetupMFAPage,
	},
	{
		path: '/daftar',
		name: 'signup',
		/* @ts-ignore */
		component: AuthPage,
		props: (route: Route) => ({
			redirectUrl: extractRedirectUrl(route),
			authType: 'signup'
		}),
	},
	{
		path: '/ganti-kata-sandi',
		name: 'change_password',
		component: ChangePasswordPage,
		props: (route) => ({ token: route.query.token }),
	},
	{
		path: '/buat-kata-sandi',
		name: 'generate_password',
		component: GeneratePasswordPage,
		props: (route) => ({ userId: route.query.userId }),
	},
	{
		path: '/consent-grant/:consentCode',
		name: 'consent_grant',
		component: AutoApproveConsentGrantPage,
		props: (route) => ({ consentCode: route.params.consentCode }),
	},
	{
		path: '/consent/:consentCode',
		name: 'consent',
		component: FormConsentGrantPage,
		props: (route) => ({ consentCode: route.params.consentCode }),
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((_, __, next) => {
	document.title = "Achilles"

	next()
})

export default router
